import React from 'react';
import * as Aphrodite from 'aphrodite/no-important';

require('../css/base_components.less');

const baseStyles = _createStyleSheet({
  scrollerStyle: {
    overflowX: 'hidden',
    overflowY: 'scroll',
    overflowScroll: 'contain',
  },
  contentContainerStyle: {
    overflowX: 'auto',
    overflowY: 'auto',
  },
});

export class View extends React.PureComponent<any> {
  render() {
    const {
      style,
      children,
      className: extraClass,
      pointerEvents: _,
      getDiv,
      ...other_props
    } = this.props;

    const { inlineStyle, className } = _resolveStyle(style, extraClass);

    const extra_props = {};
    if (getDiv) {
      extra_props.ref = getDiv;
    }

    return (
      <div
        className={className}
        style={inlineStyle}
        {...other_props}
        {...extra_props}
      >
        {children}
      </div>
    );
  }
}

export class ScrollView extends React.PureComponent<any> {
  addScrollTop(delta) {
    if (this._containerRef) {
      this._containerRef.scrollTop += delta;
    }
  }
  setScrollTop(value) {
    if (this._containerRef) {
      this._containerRef.scrollTop = value;
      return this._containerRef.scrollTop;
    }
  }

  _onContainerRef = ref => {
    this._containerRef = ref;
  };

  render() {
    const {
      style,
      contentContainerStyle,
      children,
      onScroll,
      ...other_props
    } = this.props;

    return (
      <View style={[baseStyles.scrollerStyle, style]} {...other_props}>
        <View
          getDiv={this._onContainerRef}
          style={[baseStyles.contentContainerStyle, contentContainerStyle]}
          onScroll={onScroll}
        >
          {children}
        </View>
      </View>
    );
  }
}

export class TouchableWithoutFeedback extends React.PureComponent<any> {
  render() {
    const {
      style,
      className: extraClass,
      children,
      onPress,
      ...other_props
    } = this.props;

    const { className, inlineStyle } = _resolveStyle(style, extraClass);

    return (
      <div
        onclick={onPress}
        className={className + ' touchable-without-feedback'}
        style={inlineStyle}
        {...other_props}
      >
        {children}
      </div>
    );
  }
}

function nop() {}

export class TouchableHighlight extends React.PureComponent<any> {
  static defaultProps = {
    underlayColor: 'rgba(0,0,0,0.5)',
  };

  render() {
    const {
      style,
      children,
      underlayColor,
      pointerEvents: _,
      onPress,
      ...other_props
    } = this.props;

    const { className, inlineStyle } = _resolveStyle(style);

    const inner_style = { backgroundColor: underlayColor };

    return (
      <div
        className={className + ' touchable-highlight'}
        ontouchstart={nop}
        onclick={onPress}
        style={inlineStyle}
        {...other_props}
      >
        <div className='touchable-highlight-underlay' style={inner_style} />
        {children}
      </div>
    );
  }
}

export class Text extends React.PureComponent<any> {
  render() {
    const { style, children, pointerEvents: _, ...other_props } = this.props;

    const { className, inlineStyle } = _resolveStyle(style);

    return (
      <div className={className} style={inlineStyle} {...other_props}>
        {children}
      </div>
    );
  }
}
export class TextInput extends React.PureComponent<any> {
  _onChange = e => {
    const { onChangeText } = this.props;
    if (onChangeText) {
      onChangeText(e.target.value);
    }
  };

  render() {
    const {
      style,
      className: extraClass,
      onSubmitEditing,
      multiline,
      ...other_props
    } = this.props;

    const { className, inlineStyle } = _resolveStyle(style, extraClass);

    let input;
    if (multiline) {
      input = (
        <textarea
          className={'base-component-text-input ' + className}
          style={inlineStyle}
          onChange={this._onChange}
          onInput={this._onChange}
          {...other_props}
        />
      );
    } else {
      input = (
        <input
          className={'base-component-text-input ' + className}
          style={inlineStyle}
          onChange={this._onChange}
          onInput={this._onChange}
          {...other_props}
        />
      );
    }
    let content;
    if (onSubmitEditing) {
      content = (
        <form
          className={'base-component-text-input-form'}
          onSubmit={onSubmitEditing}
        >
          {input}
        </form>
      );
    } else {
      content = input;
    }
    return content;
  }
}

export class Image extends React.PureComponent<any> {
  static defaultProps = {
    resizeMode: 'contain',
  };

  render() {
    const { style, resizeMode, source } = this.props;

    const { className, inlineStyle } = _resolveStyle(style);

    inlineStyle.backgroundSize = resizeMode;
    inlineStyle.backgroundRepeat = 'no-repeat';
    inlineStyle.backgroundPosition = 'center center';

    if (source && source.src) {
      inlineStyle.backgroundImage = "url('" + source.src + "')";
    } else {
      inlineStyle.backgroundImage = "url('" + source + "')";
    }

    return <div className={className} style={inlineStyle} />;
  }
}

function _resolveStyle(style, extra_class) {
  let className = 'base-component ';
  const inlineStyle = {};
  const aphrodite_style_list = [];

  function _handleStyle(style) {
    if (style && style._name) {
      aphrodite_style_list.push(style);
    } else if (Array.isArray(style)) {
      style.forEach(_handleStyle);
    } else if (typeof style === 'object' && style) {
      Object.assign(inlineStyle, style);
    }
  }
  _handleStyle(style);
  if (aphrodite_style_list.length > 0) {
    className += css(aphrodite_style_list);
  }
  if (extra_class) {
    className += ' ' + extra_class;
  }
  return {
    className,
    inlineStyle,
  };
}

function _createStyleSheet<T>(style_map: T): T {
  return Aphrodite.StyleSheet.create(style_map);
}

let g_dimensions;
let g_resizeSet = false;
function _getDimensions() {
  if (!g_dimensions) {
    const app_container = document.getElementById('app-container');
    if (!g_resizeSet) {
      g_resizeSet = true;
      window.addEventListener('resize', _onResize);
    }

    g_dimensions = {
      width: app_container.clientWidth,
      height: app_container.clientHeight,
    };
  }
  return g_dimensions;
}
function _onResize() {
  g_dimensions = false;
}

export const StyleSheet = {
  create: _createStyleSheet,
};
export const Dimensions = {
  get: _getDimensions,
};
export const PixelRatio = {
  get: () => window.devicePixelRatio || 1,
};

function css(...args) {
  return Aphrodite.css(...args);
}

export default {
  StyleSheet,
  View,
  ScrollView,
  Text,
  TextInput,
  Image,
  TouchableHighlight,
  TouchableWithoutFeedback,
  Dimensions,
  PixelRatio,
  css,
};
